import { atom } from "jotai";

export const transparentOverlay = atom(false);
